import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import { useEffect, useRef } from 'react';
import TwitterSidebar from './Sidebar';
import View from './View';

interface TwitterEditProps {
  block: string;
  data: {
    twitter_username?: string;
  };
  onChangeBlock: (block: string, data: any) => void;
  selected: boolean;
  [key: string]: any; // Add index signature for any other props
}

const TwitterEdit = (props: TwitterEditProps) => {
  const { block, data, onChangeBlock, selected } = props;
  console.log('twitter edit', block, data);
  const editable = useRef<any>(null);

  useEffect(() => {
    if (selected && editable.current) {
      editable.current.focus();
    }
  }, [selected]);

  return (
    <div className="block">
      <div className="junts-heading-wrapper">
        <View {...props} />
        <SidebarPortal selected={selected}>
          <TwitterSidebar
            {...props}
            data={data}
            block={block}
            onChangeBlock={onChangeBlock}
          />
        </SidebarPortal>
      </div>
    </div>
  );
};

export default withBlockExtensions(TwitterEdit);
